import DBFields from "./DBFields";

export default function DBSelector({
  title,
  type,
  setType,
  dbName,
  setDbName,
  collection,
  setCollection,
  apiKey,
  setApiKey,
  url,
  setUrl,
  namespace,
  setNamespace,
  batchSize,
  setBatchSize,
  embeddingField,
  setEmbeddingField,
  isTarget,
}) {
  return (
    <div className="bg-white p-6 rounded-2xl shadow-sm w-full max-w-5xl mx-auto border border-border">

      <h3 className="text-xl font-semibold mb-4 text-text-primary">{title}</h3>

      {/* Database Selector */}
      <select
        value={type}
        onChange={(e) => setType(e.target.value)}
        className="p-3 rounded-lg bg-bg-soft border border-border w-full mb-4 text-text-primary focus:outline-none focus:ring-2 focus:ring-accent transition"
      >
        <option value="">Select Database</option>
        <option value="pinecone">Pinecone</option>
        <option value="milvus">Milvus</option>
        <option value="qdrant">Qdrant</option>
        <option value="chroma">ChromaDB</option>
        <option value="weaviate">Weaviate</option>
        <option value="mongo">MongoDB</option>
        <option value="pgvector">PGVector</option>
      </select>

      {/* Dynamic Fields */}
      {type && (
        <DBFields
          type={type}
          isTarget={isTarget}
          dbName={dbName}
          setDbName={setDbName}
          collection={collection}
          setCollection={setCollection}
          apiKey={apiKey}
          setApiKey={setApiKey}
          url={url}
          setUrl={setUrl}
          namespace={namespace}
          setNamespace={setNamespace}
          batchSize={batchSize}
          setBatchSize={setBatchSize}
          embeddingField={embeddingField}
          setEmbeddingField={setEmbeddingField}
        />
      )}
    </div>
  );
}